import { BoolShould, RangeQuery, StatefulAccessor, ValueState } from 'searchkit';
import moment from 'moment';

// Import presets and messages from SearchDateRangeControl
import { presets, messages } from './SearchDateRangeControl';

class RangeQueryAccessor extends StatefulAccessor {
  constructor(key, field, options = {}) {
    super(key);
    this.field = field;
    this.state = new ValueState();
    this.options = options;
    this.intl = options.intl; // Store intl from options
  }

  fromQueryObject(ob) {
    let q = ob;
    if (ob && ob[this.key] && ob[this.key].length) {
      q = {
        ...ob,
        key: ob[this.key].map(o => (o === '' ? null : o)),
      };
    }
    super.fromQueryObject(q);

    // If no values are set and we have initial values in options, set them
    if (
      !this.state.getValue() &&
      this.options.initialValue &&
      this.options.initialValue.length > 0
    ) {
      const [min, max] = this.options.initialValue;
      this.state = this.state.setValue([min, max]);
    }

    if (this.options.onQueryStateChange) {
      this.options.onQueryStateChange(this.state.value);
    }
  }

  keepOnlyQueryState() {
    this.setQueryString(this.getQueryString(), true);
  }

  clear() {
    this.state = this.state.setValue([]);
  }

  setValues(min, max, withReset = false) {
    if (withReset) {
      this.searchkit.resetState();
    }
    this.state = this.state.setValue([min, max]);
  }

  getValues() {
    return this.state.getValue();
  }

  buildSharedQuery(q) {
    let query = q;
    const value = this.state.getValue();
    if (value?.length > 0) {
      const [gte, lte] = value;
      const queryBuilder = this.options.queryBuilder || RangeQuery;
      const simpleQuery = queryBuilder(this.field, { gte, lte, ...this.options.queryOptions });
      query = query.addQuery(BoolShould([simpleQuery]));

      // Check if this matches a preset
      const preset = presets.find(p => p[1] === gte && p[2] === lte);
      let displayValue;

      if (preset) {
        // Translate the preset name using intl from options
        displayValue = this.intl ? this.intl.formatMessage(messages[preset[0]]) : preset[0];
      } else {
        // Fall back to formatted dates for custom ranges
        const dateFormatter = this.options.dateFormatter || (d => moment(d).format('YYYY-MM-DD'));
        displayValue = `${gte ? dateFormatter(gte) : ''} - ${lte ? dateFormatter(lte) : ''}`;
      }

      query = query.addSelectedFilter({
        name: preset ? ' ' : this.options.title, // Use space instead of empty string to avoid colon
        value: displayValue,
        id: this.key,
        remove: () => {
          this.state = this.state.clear();
          return this.state;
        },
      });
      return query;
    }
    return query;
  }
}

export default RangeQueryAccessor;
